export default {
    data() {
        return {
            selected: [],
            templateType: '',
            mailer: '',
            total: 0,
            totalAmount: 0,
            clientType: '',
            valid: false,
            isLoading: false,
            isSendMailToAll: false,
            isNewsletterBtnLoading: false,
            showMailConfirm: false,
            showDeleteConfirm: false,
            currentSelectedItem: null,
            showFilesPopup: false,
            showLinkPopup: false,
            showMergedLinkPopup: false,
            showMergedMailConfirm: false,
            showMergedUpdateMailConfirm: false,
            showManualPaymentPopup: false,
            showManualMergedPaymentPopup: false,
            showRestoreConfirm: false,
            showResendMailConfirm: false,
            showResetInvoiceConfirm: false,
            showSoftDeleteConfirm: false,
            showReminderMailConfirm: false,
            showAfterReminderMailConfirm: false,
            showRepublishConfirm: false,
            showRefundConfirm: false,
            showRepublishMailConfirm: false,
            showConfirm: false,
            showConfirmMoz: false,
            showEmailTimeliner: false,
            startDate: '',
            endDate: '',
            searchUser: '',
            paymentStatus: '',
            deleteStatus: '',
            payMethod: '',
            searchEmail: '',
            payStatus: [
                {name: 'Unpaid', id: 100},
                {name: 'Paid', id: 200},
                {name: 'Refunded', id: 400},
                {name: 'Republish', id: 600}
            ],
            dStatus: [
                {name: 'Is Deleted', id: 500}
            ],
            limitList: [5, 10, 20, 50, 100],
            pagination: {
                itemsPerPage: 50
            },
            searchLength: 2,
            searchLimit: 250,
            showPopup: false,
            errorMessage: '',
            editedItem: {},
            defaultActionButtons: [
                {
                    category: 'edit',
                    icon: 'mdi-pencil',
                    color: '',
                    text: 'Edit',
                    clickHandler: this.editItem
                },
                {
                    category: 'delete',
                    icon: 'mdi-delete',
                    color: 'error',
                    text: 'Delete',
                    clickHandler: this.softDeleteHandler
                },
                {
                    category: 'deletePermanent',
                    icon: 'mdi-delete-alert',
                    color: 'error',
                    text: 'Delete Permanently',
                    clickHandler: this.deleteItem
                }
            ],
            searchTerm: '',
            mailTemplates: [
                {name: 'Resend Payment Email', id: '100'},
                {name: 'After Post Removal Payment Email', id: '400'},
                {name: 'News Letter 1', id: '500'},
                {name: 'News Letter 2', id: '600'}
            ],
            mailSenders: [
                {name: 'Contact', id: 'contact'},
                {name: 'Sales', id: 'sales'},
            ],
            emailTypes: [
                {id: 1, name: 'Reseller Clients'},
                {id: 2, name: 'Fix Clients'},
                {id: 3, name: 'Special Clients'},
                {id: 4, name: 'Agency Clients'},
                {id: 5, name: 'Agency Clients 2025'},
                {id: 6, name: 'Agency Clients 2'},
                {id: 7, name: 'Agency Clients 3'},
                {id: 8, name: 'New Clients 2025'},
                {id: 9, name: 'New Clients 2 2025'},
            ],
            clientTypes: [
                {id: 2, name: 'Fix Clients'},
                {id: 3, name: 'Special Clients'},
                {id: 4, name: 'Agency Clients'}
            ]
        }
    },
}